import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Popover,
  RadioGroup,
  makeStyles,
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import clsx from 'clsx';
import { Button } from '../../atomicComponents';
import styles from './NextMonthVinForm.module.css';
import { withAllowedOperationsProvider } from '../../hocs';
import { RESOURCE_TYPE } from '../../constants';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { buildErrorMessage } from '../../apis/calls';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';

const NextMonthVinForm = ({
  open,
  anchorEl,
  closeForm,
  asns,
  reloadData,
  isLoading,
  nextMonthVINRequest, 
  classNames,
}) => {

  const [plant] = usePlantAndLinesStore().plantState
  const isLucknowProlifePlant = plant?.label === 'Lucknow-Prolife'
  const parentName = isLucknowProlifePlant ? 'ENG' : 'VIN'

  const { showSuccess, showInternalError, showLoading, closePopUp } =
    usePopupManager();

  const [selectedValue, setSelectedValue] = useState(true);

  const handleValueChange = (e) => {
    setSelectedValue(e.target.value === 'true');
  };

  const handleApply = async () => {
    try {
      showLoading();
      await nextMonthVINRequest(asns, selectedValue);
      closeForm();
      reloadData();
      closePopUp();
      showSuccess({
        contextText: `Next Month ${parentName} updated successfully`,
      });
    } catch (error) {
      console.error(buildErrorMessage(error));
      showInternalError();
    }
  };

  const useStyles = makeStyles(() => ({
    backDrop: {
      backdropFilter: 'blur(3px)',
      backgroundColor: 'rgba(0,0,30,0.4)',
    },
  }));

  const classes = useStyles();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={closeForm}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      className={clsx(styles.paper, classNames?.assignShiftFormPaper)}
      BackdropProps={{
        classes: { root: classes.backDrop },
      }}
    >
      {isLoading ? (
        <div className={clsx(styles.loaderIcon, styles.formBox)}>
          <CircularProgress />
        </div>
      ) : (
        <FormControl className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Next Month {parentName}</span>
            <div className={styles.formlLineDiv} />
          </div>

          <Box
            bgcolor="#dadada3d"
            paddingTop="8px"
            paddingBottom="8px"
            borderRadius="6px"
            style={{ marginBottom: '12px' }}
          >
            <RadioGroup
              name="nextMonthVin"
              value={selectedValue.toString()}
              onChange={handleValueChange}
            >
              <FormControlLabel
                value="true"
                control={<Radio color="default" />}
                label="True"
                className={styles.radioLabel}
              />

              <FormControlLabel
                value="false"
                control={<Radio color="default" />}
                label="False"
                className={styles.radioLabel}
              />
            </RadioGroup>
          </Box>

          <div style={{ float: 'right' }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.applyOrCloseButton)}
              onClick={handleApply}
            >
              APPLY
            </Button>
          </div>
        </FormControl>
      )}
    </Popover>
  );
};

NextMonthVinForm.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  closeForm: PropTypes.func.isRequired,
  asns: PropTypes.array.isRequired,
  reloadData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  nextMonthVINRequest: PropTypes.func.isRequired,
  classNames: PropTypes.object,
};

export default withAllowedOperationsProvider(
  NextMonthVinForm,
  false,
  RESOURCE_TYPE.CHASSIS,
);
